export const EFFECT_VALUE_DIVISOR = 100;
export const DEFAULT_ENTROPY = 0.2;
